import { Pipe, PipeTransform } from '@angular/core';
import {Passenger} from "@app/models/micro";

@Pipe({
    name: 'shortUUID',
    standalone: false
})
export class ShortUUIDPipe implements PipeTransform {
  transform(uuid: string) {
    return uuid?.substring(0,16) ?? '';
  }
}

@Pipe({
    name: 'nameinitials',
    standalone: false
})
export class NameInitialsPipe implements PipeTransform {
  transform(passenger: Passenger) {
    return passenger? `${passenger.firstName.substring(0,2)}${passenger.lastName[0]}`:"";
  }
}
